package com.karawek.core.auth.stytch

import com.karawek.core.auth.model.OtpHandle
import com.karawek.core.circuit.Parcelize

@Parcelize
internal data class StytchOtpHandle(
    val methodId: String,
) : OtpHandle
